/**
 * „beenden“ im Sprachgespräch (gleiche Regel wie der Server, VoiceTools.IsEndCommand): Nur wenn die ganze Äußerung ein
 * Beenden-Befehl ist – „Danke, und noch Milch“ oder „Training endet um 5“ beenden nichts.
 */
const PRE = String.raw`(?:(?:ok|okay|ja|gut|bitte|danke|computer|hey|hallo|friday|jarvis)\s+)*`;
const OBJ = String.raw`(?:(?:den|das|die)\s+)?(?:voice\s?mode|voicemode|sprachmodus|sprachassistent|gespräch|unterhaltung|assistent|alles)`;
const END = String.raw`(?:beenden|beende|ende|aus|stopp|stop|schluss|tschüss|tschau|ciao|auf wiedersehen|das wars|fertig|auflegen|leg auf|danke|danke schön|dankeschön|vielen dank)`;
const POST = String.raw`(?:\s+(?:danke|bitte|computer|friday|jarvis|tschüss))*`;
const END_PATTERN = new RegExp(String.raw`^${PRE}(?:(?:${OBJ}\s+)?${END}|(?:beende|beenden|stopp|stop|schließe|schließen)\s+${OBJ})${POST}$`, "i");

export function isEndCommand(utterance: string | null | undefined): boolean {
  if (!utterance) return false;
  const text = utterance.toLowerCase().replace(/['’]/g, "").split(/[\s.,!?;:„“"-]+/).filter(Boolean).join(" ");
  return text.length > 0 && text.length <= 60 && END_PATTERN.test(text);
}
